import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@mui/styles";
import { Link, BrowserRouter as Router, Redirect } from "react-router-dom";
import axios from "axios";
import {
  ActionPlansProvider,
  ActionPlansContext,
} from "context/ActionPlansContext";
import UserService from "services/UserService";
import { getActionPlan } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomTabs2 from "components/CustomTabs2/CustomTabs2";
import TabHeader from "components/Ui/Header/TabHeader";
import AboutTabs from "./About/AboutTabs";
import Analysis from "./Dashboard/Analysis";
import RTActions from "./Actions/RTActions";
import ActionsAnalysis from "./Actions/ActionsAnalysis";
import RTScenarios from "./Scenarios/RTScenarios";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CustomConfirmationDialog from "components/CustomDialog/CustomConfirmationDialog";
import {
  Navigate, useLocation
} from "react-router-dom";


export default function SelectedPlanActions(props) {
  const { state } = useLocation();
  if (!state) {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/actionplans",
        }}
      />
    )
  }
  else {
    const { planActionId, planActionName } = state;
    // let planActionId = props?.location?.state?.planActionId || "";
    // let planActionName = props?.location?.state?.planActionName || "";
    return (
      <ActionPlansProvider>
        <SelectedPlanActionsChild
          planActionId={planActionId}
          planActionName={planActionName}
        />
      </ActionPlansProvider>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function SelectedPlanActionsChild({ planActionId, planActionName }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setOutofcontextclic, setChartIdGroup, selectedNodesInfo, setSelectedNodesInfo } = advancedSearchContext;
  const classes = useStyles();
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const [prevIdGroup, setPrevIdGroup] = useState(["0"]);
  const [prevNodesInfo, setPrevNodesInfo] = useState("");
  const [openExitConfirmation, setOpenExitConfirmation] = useState(false);
  const [redirState, setRedirState] = useState(false);
  const { parameters } = actionPlans;

  const [isLoading, setIsLoading] = useState(true);

  const url = getActionPlan(planActionId);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/actionplans",
      }}
    />
  );

  useEffect(() => {
    axios
      .get(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setActionPlans(response.data || []);
        setIsLoading(false);
      });
  }, [planActionId]);

  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if (prevIdGroup && prevIdGroup[0] === chartIdGroup[0]) {
        return;
      }
      else if (prevIdGroup[0] !== "0") {
        setOpenExitConfirmation(true,);
      }
      else {
        setPrevIdGroup([...chartIdGroup]);
        setPrevNodesInfo(selectedNodesInfo);
      }
    }
    else {
      setPrevIdGroup([...chartIdGroup]);
      setPrevNodesInfo(selectedNodesInfo);
    }
  }, [chartIdGroup]);

  const handleClose = (e) => {
    setOutofcontextclic(prevIdGroup);
    setChartIdGroup(prevIdGroup);
    setSelectedNodesInfo(prevNodesInfo);
    setOpenExitConfirmation(false);
  };

  const handleExit = (e) => {
    setOpenExitConfirmation(false);
    setRedirState(true);
  };

  if (planActionId === "") {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/actionplans",
        }}
      />
    );
  }




  let actions = actionPlans?.actions || [];
  let scenarios = actionPlans?.scenarios || [];

  let actionsLength = actions.length || 0;
  let scenariosLength = scenarios.length || 0;

  const data2 = [
    {
      value: "0",
      label: "À propos",
      component: (
        <div
          style={{
            //boxShadow: "0 1px 4px 0 grey",
            //borderRadius: "6px",
            //padding: "0.3rem 0.6rem",
            backgroundColor: "white",
            marginTop: "0.5rem",
          }}
        >
          <AboutTabs
            {...parameters}
            scenarios={actionPlans.scenarios}
            planActionId={planActionId}
          />
        </div>
      ),
    },
    {
      value: "1",
      label: `Gerer les scénarios (${scenariosLength})`,
      component: (
        <RTScenarios
          planActionId={planActionId}
          planActionName={planActionName}
        />
      ),
    },
    {
      value: "2",
      label: `Gerer les actions (${actionsLength})`,
      component: (
        <div
          style={{
            margin: "0rem -0.8rem",
          }}
        >
          <ActionsAnalysis />
          <div
            style={{
              //boxShadow: "0 1px 4px 0 grey",
              //borderRadius: "6px",
              //padding: "0 0.6rem",
              margin: "1rem 0.3rem 0rem",
              backgroundColor: "white",
            }}
          >
            {" "}
            <RTActions
              planActionId={planActionId}
              planActionName={planActionName}
            />
          </div>
        </div>
      ),
    },
    // {
    //   admin : true,
    //   value: "3",
    //   label: "Tableau de bord",
    //   component: (
    //     <div
    //       style={{
    //         margin: "0rem -0.8rem",
    //       }}
    //     >
    //       <Analysis />
    //     </div>
    //   ),
    // },
    // {
    //   admin : true,
    //   value: "4",
    //   label: "Simulations",
    //   component: (
    //     <div
    //       style={{
    //         margin: "0rem -0.8rem",
    //       }}
    //     >
    //       <Analysis />
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <TabHeader>
            <>
              <Link to="/admin/actionplans">
                <div
                  style={{
                    fontSize: "13px",
                    color: "#fff",
                    opacity: "0.8",
                  }}
                >
                  {/* <KeyboardBackspaceIcon /> */}
                  Plans d'actions
                </div>
              </Link>
              <div
                style={{
                  marginLeft: "5px",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                / {planActionName}
              </div>
            </>
          </TabHeader>
        </GridItem>

        <GridItem xs={12}>
          {!isLoading && (
            <div className={classes.demo2}>
              <CustomTabs2 data={data2} />
            </div>
          )}
        </GridItem>
      </GridContainer>
      <CustomConfirmationDialog
        open={openExitConfirmation}
        handleClose={handleClose}
        handleExit={handleExit}
        dialogContent={"Etes vous sur de vouloir sortir du plan d'action?"}
        id={"draggable-dialog-title"}
      />
      {redirecting}
    </>

  );
}
